import { defineComponent, onBeforeMount } from 'vue-demi';
import { s as script$4 } from './ServiceNavigationDropdown-0e5fe995.js';
import { s as script$2 } from './ServiceNavigationLogo-7f81b2a6.js';
import { s as script$3 } from './ServiceNavigationContent-077741fa.js';
import { s as script$5 } from './ServiceNavigationFooter-12996c14.js';
import { s as script$1 } from './ServiceNavigationUtilitiesMenu-6f9189e9.js';
import { s as script$6 } from './ServiceNavigationNotifications-ce72227c.js';
import _ from 'lodash';
import { S as SERVICES } from './services-8eb03020.js';
import { useResponsive } from '@onereach/ui-components';
import { u as useUserServiceNavigationFavoritesServicesSettings, a as useServiceDiscoveryUiServices, b as useIdwService } from './useIdwService-5d3a26cb.js';
import { u as useI18n } from './useI18n-b41ba0b3.js';
import { resolveComponent, openBlock, createElementBlock, createElementVNode, createVNode, withCtx, renderSlot, createBlock, createCommentVNode } from 'vue';
export { s as ServiceNavigationBreadcrumbs } from './ServiceNavigationBreadcrumbs-029b507d.js';
export { s as ServiceNavigationMenu } from './ServiceNavigationMenu-4efbe94f.js';
import '@vueuse/core';
import './constants/index.js';
import '@or-sdk/chat';
import './ServiceNavigationButton-4dfba521.js';
import './EmojiPicker-4cfbc9d9.js';
import '@onereach/emoji-picker-element';
import '@or-sdk/notifications';
import 'lodash/orderBy';
import 'lodash/uniqBy';
import '@or-sdk/discovery';
import '@or-sdk/settings';
import '@or-sdk/idw';

function prepareLocaleMessage(serviceKey, translations) {
  return _.mapValues(translations, t => ({
    services: {
      [_.kebabCase(serviceKey)]: t
    }
  }));
}
function prepareLocaleMessages(services) {
  return _.mapValues(_.groupBy(_.flatMap(services, s => _.map(_.entries(s.translations), t => ({
    key: s.serviceKey,
    locale: t[0],
    translation: t[1]
  }))), msg => msg.locale), msgs => ({
    'services': _.fromPairs(_.map(msgs, msg => [msg.key, msg.translation]))
  }));
}
function getServiceLabel(service) {
  return `services.${_.isString(service) ? service : service.serviceKey}.label`;
}
function extractDropdownItems(services, activeLabel) {
  var _a, _b;
  let lastOrder = (_a = services === null || services === void 0 ? void 0 : services.reduce((prev, curr) => curr.order ? Math.max(prev, curr.order) : prev, 0)) !== null && _a !== void 0 ? _a : 0;
  return (_b = services === null || services === void 0 ? void 0 : services.map(item => {
    var _a, _b, _c;
    return {
      label: getServiceLabel(item),
      active: activeLabel === getServiceLabel(item),
      url: (_a = item.url) !== null && _a !== void 0 ? _a : '/',
      id: item.serviceKey,
      order: (_b = item.order) !== null && _b !== void 0 ? _b : ++lastOrder,
      logo: (_c = item.logo) !== null && _c !== void 0 ? _c : ''
    };
  })) !== null && _b !== void 0 ? _b : [];
}
function extractServiceLocaleMessages(config, translations) {
  var _a;
  const serviceKey = (_a = SERVICES[config.service]) !== null && _a !== void 0 ? _a : config.service;
  return prepareLocaleMessage(serviceKey, translations);
}
function extractServiceLabel(config, services) {
  var _a;
  const serviceKey = (_a = SERVICES[config.service]) !== null && _a !== void 0 ? _a : _.kebabCase(config.service);
  if (services && !services.some(s => s.serviceKey === serviceKey)) {
    // eslint-disable-next-line max-len
    console.error(`Cannot recognize service '${serviceKey}'. Visit https://gitlab.internal.onereach.io/onereach/platform/ui-modules/service-navigation#add-logo-and-translations-to-projectconfig-in-packagejson-of-new-project`);
  }
  return getServiceLabel(serviceKey);
}
function getUtilitiesMenuItemsConfig(config, token = '') {
  return {
    ...config.UTILS_MENU_LIST,
    token
  };
}
function getHomePageUrl(config) {
  return config.REPORTING_URL;
}

var script = defineComponent({
  components: {
    ServiceNavigationUtilitiesMenu: script$1,
    ServiceNavigationLogo: script$2,
    ServiceNavigationContent: script$3,
    ServiceNavigationDropdown: script$4,
    ServiceNavigationFooter: script$5,
    ServiceNavigationNotifications: script$6
  },
  props: {
    label: {
      type: String,
      default: null
    },
    showUtilsMenu: {
      type: Boolean,
      default: true
    },
    config: {
      type: Object,
      required: true
    },
    token: {
      type: String,
      required: false,
      default: null
    },
    showServices: {
      type: Boolean,
      default: true
    },
    serviceTranslations: {
      type: Object,
      default: null
    },
    breadcrumbItems: {
      type: Array,
      default: () => []
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    showNotifications: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const {
      initializeI18n,
      mergeLocaleMessages
    } = useI18n();
    const {
      isDesktop
    } = useResponsive();
    const {
      getUserFavoritesServices,
      toggleUserFavoritesServices
    } = useUserServiceNavigationFavoritesServicesSettings(() => props.token, {
      sdkUrl: props.config.SDK_API_URL
    });
    const {
      uiServices
    } = useServiceDiscoveryUiServices(() => props.token, {
      discoveryUrl: props.config.SERVICE_DISCOVERY_API_URL
    }, props.config.FEATURE);
    const {
      isIdwAccount,
      idwInfo
    } = useIdwService(() => props.token, {
      discoveryUrl: props.config.SERVICE_DISCOVERY_API_URL,
      emUrl: props.config.EM_URL,
      providerAccountId: props.config.PROVIDERS_ACCOUNT_ID
    });
    onBeforeMount(initializeI18n);
    return {
      initializeI18n,
      mergeLocaleMessages,
      isDesktop,
      getUserFavoritesServices,
      toggleUserFavoritesServices,
      uiServices,
      isIdwAccount,
      idwInfo
    };
  },
  computed: {
    serviceItems() {
      return extractDropdownItems(this.uiServices, this.projectLabel);
    },
    projectLabel() {
      return this.label || extractServiceLabel(this.config, this.uiServices);
    },
    targetUrl() {
      return getHomePageUrl(this.config);
    },
    logoUrl() {
      return this.config.LOGO_URL || undefined;
    },
    utilitiesMenuItemsConfig() {
      return getUtilitiesMenuItemsConfig(this.config, this.token);
    },
    service() {
      return this.config.service;
    }
  },
  watch: {
    uiServices(val) {
      if (!(val === null || val === void 0 ? void 0 : val.length)) return;
      const localeMessages = prepareLocaleMessages(val);
      this.mergeLocaleMessages(localeMessages);
    },
    serviceTranslations: {
      handler(val) {
        if (val) {
          const localeMessages = extractServiceLocaleMessages(this.config, val);
          this.mergeLocaleMessages(localeMessages);
        }
      },
      immediate: true
    }
  }
});

const _hoisted_1 = {
  class: "layout-column",
  "data-test": "service-navigation"
};
const _hoisted_2 = {
  class: "layout-row h-2xl justify-between bg-black px-md md:px-xl"
};
const _hoisted_3 = {
  class: "layout-row grow gap-md overflow-hidden sm:gap-xl"
};
const _hoisted_4 = {
  class: "layout-row gap-md pl-sm sm:pl-xl"
};
const _hoisted_5 = {
  key: 2,
  "data-test": "account-container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_service_navigation_logo = resolveComponent("service-navigation-logo");
  const _component_service_navigation_dropdown = resolveComponent("service-navigation-dropdown");
  const _component_service_navigation_content = resolveComponent("service-navigation-content");
  const _component_service_navigation_notifications = resolveComponent("service-navigation-notifications");
  const _component_service_navigation_utilities_menu = resolveComponent("service-navigation-utilities-menu");
  const _component_service_navigation_footer = resolveComponent("service-navigation-footer");
  return openBlock(), createElementBlock("header", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [createVNode(_component_service_navigation_logo, {
    "logo-url": _ctx.logoUrl,
    "target-url": _ctx.targetUrl,
    service: _ctx.service
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "logo")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["logo-url", "target-url", "service"]), _ctx.showServices ? (openBlock(), createBlock(_component_service_navigation_dropdown, {
    key: 0,
    "dropdown-items": _ctx.serviceItems,
    "project-label": _ctx.projectLabel,
    "favorites-services": _ctx.getUserFavoritesServices,
    "idw-info": _ctx.idwInfo,
    "is-idw-account": _ctx.isIdwAccount,
    "project-id": _ctx.service,
    onToggleFavorite: _ctx.toggleUserFavoritesServices
  }, null, 8 /* PROPS */, ["dropdown-items", "project-label", "favorites-services", "idw-info", "is-idw-account", "project-id", "onToggleFavorite"])) : createCommentVNode("v-if", true), _ctx.isDesktop ? (openBlock(), createBlock(_component_service_navigation_content, {
    key: 1,
    "menu-items": _ctx.menuItems
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "content")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["menu-items"])) : createCommentVNode("v-if", true)]), createElementVNode("div", _hoisted_4, [_ctx.showNotifications && _ctx.token && _ctx.config.NOTIFICATIONS_API_URL ? (openBlock(), createBlock(_component_service_navigation_notifications, {
    key: 0,
    config: _ctx.config,
    token: _ctx.token
  }, null, 8 /* PROPS */, ["config", "token"])) : createCommentVNode("v-if", true), _ctx.showUtilsMenu ? (openBlock(), createBlock(_component_service_navigation_utilities_menu, {
    key: 1,
    config: _ctx.utilitiesMenuItemsConfig
  }, null, 8 /* PROPS */, ["config"])) : createCommentVNode("v-if", true), _ctx.$slots.account ? (openBlock(), createElementBlock("div", _hoisted_5, [renderSlot(_ctx.$slots, "account")])) : createCommentVNode("v-if", true)])]), createVNode(_component_service_navigation_footer, {
    "breadcrumb-items": _ctx.breadcrumbItems,
    "menu-items": _ctx.menuItems,
    "data-testid": "navigation-footer"
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["breadcrumb-items", "menu-items"])]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationHeader.vue";

export { script as ServiceNavigationHeader };
